import {
  PersonalScheduleDetailPage,
  WeeklyCalenderDetail,
  WeeklyCalenderDetailForAdmin,
  WeeklyCalenderScheduleRegistration,
  WeeklyCalenderSearch,
  WeeklyCalenderSearchLecture,
  WeeklyRepeat
} from '#pages';
import WeeklyCalenderMembership from '#pages/WeeklyCalenderMembership';
import { useScheduleManage } from '#providers/SchedulesManage';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { Fragment } from 'react';
import { Route, Routes } from 'react-router';
import { WeeklyCalendarPage } from 'src/components/pages/WeeklyCalendarPage';

export function ScheduleManageView() {
  const { clearSelectedLecture } = useScheduleManage();

  const handleClickPrev = (prevPathname?: string) => {
    // 일정추가에서 뒤로가기 시 state clear
    if (prevPathname === '/calender/schedule-registration') {
      clearSelectedLecture();
    }
  };

  return (
    <Fragment>
      <Routes>
        <Route path="/detail/:lectureId" element={<WeeklyCalenderDetail />} />
        <Route
          path="/detail/personal/:scheduleId"
          element={<PersonalScheduleDetailPage />}
        />
        <Route
          path="/detail/:lectureId/admin"
          element={<WeeklyCalenderDetailForAdmin />}
        />
        <Route
          path="/schedule-registration"
          element={<WeeklyCalenderScheduleRegistration />}
        />

        <Route
          path="/*"
          element={
            <PrevHeaderBarWithTitleTemplate
              title={'일정관리'}
              defaultBackground
              onPrevCallback={handleClickPrev}
            >
              <Routes>
                <Route path="" element={<WeeklyCalendarPage />} />
                <Route
                  path="search-client"
                  element={<WeeklyCalenderSearch />}
                />
                <Route
                  path="search-membership"
                  element={<WeeklyCalenderMembership />}
                />
                <Route
                  path="search-lecture"
                  element={<WeeklyCalenderSearchLecture />}
                />
                <Route path="repeat-lecture" element={<WeeklyRepeat />} />
              </Routes>
            </PrevHeaderBarWithTitleTemplate>
          }
        />
      </Routes>
    </Fragment>
  );
}
